import { render, staticRenderFns } from "./LiveChatDecision.vue?vue&type=template&id=cf462506&scoped=true&"
import script from "./LiveChatDecision.vue?vue&type=script&lang=js&"
export * from "./LiveChatDecision.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatDecision.vue?vue&type=style&index=0&id=cf462506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf462506",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VSelect,VTextField})
